import React, { createContext, useContext, useRef, useState } from 'react';

const NotifyContext = createContext(null);
export const useNotify = () => useContext(NotifyContext);

let idCounter = 0;

export function NotifyProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const timersRef = useRef({});

  const notify = (type, message, duration = 4000) => {
    if (!message) return;
    idCounter += 1;
    const id = idCounter;
    setToasts((prev) => [...prev, { id, type, message }]);
    timersRef.current[id] = setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
      delete timersRef.current[id];
    }, duration);
  };

  const dismiss = (id) => {
    if (timersRef.current[id]) {
      clearTimeout(timersRef.current[id]);
      delete timersRef.current[id];
    }
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  return (
    <NotifyContext.Provider value={{ notify, dismiss, toasts }}>
      {children}
    </NotifyContext.Provider>
  );
}
